import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import TitleNavBarContext from 'context/TitleNavBarContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import { UseTranslationProps } from 'types/UseTranslationProps';
import FormBannerPLP from 'components/FormBannerPLP';
import { BannerPlpProps } from 'types/BannerPlpProps';
import { getPlpBanners } from './reqs';
import Load from 'components/Load';

export default function PlpBanners() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);
	const { handleNotify } = useContext(SystemNotifyContext);

	const [isLoad, setIsLoad] = useState(false);
	const [isOpenFormBanner, setIsOpenFormBanner] = useState(false);
	const [banners, setBanners] = useState<BannerPlpProps[]>([]);
	const [bannerToEdit, setBannerToEdit] = useState<BannerPlpProps | null>(null);

	//vai buscar os dados dos banners
	useEffect(() => {
		(async () => {
			setIsLoad(true);
			const banners = await getPlpBanners(handleNotify);
			setIsLoad(false);

			setBanners(banners);
		})();
	}, []);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'Banners PLP'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			{isLoad ? (
				<S.isLoad>
					<Load showText text="Carregando banners" />
				</S.isLoad>
			) : (
				<S.list>
					{banners.length === 0 ? (
						<S.noItensOnList>
							<p>Não há banners</p>
						</S.noItensOnList>
					) : (
						banners.map((item) => (
							<S.content
								key={item.id}
								onClick={() => {
									setIsOpenFormBanner(true);
									setBannerToEdit(item);
								}}
							>
								<img src={item.urlImg} alt={item.title} />
								<p>{item.title}</p>
							</S.content>
						))
					)}
				</S.list>
			)}

			{isOpenFormBanner && (
				<FormBannerPLP
					isOpenForm={isOpenFormBanner}
					setIsOpenForm={setIsOpenFormBanner}
					bannerToEdit={bannerToEdit}
					listBanners={banners}
					setListBanners={setBanners}
					setBannerToEdit={setBannerToEdit}
				/>
			)}
		</S.container>
	);
}
